var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAufb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo Icons"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Box",
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    d: "M22.7289 20.6246L23.4383 15.9994H19.0005V12.9979C19.0005 11.7326 19.6204 10.4992 21.6081 10.4992H23.6258V6.56154C23.6258 6.56154 21.7947 6.24902 20.044 6.24902C16.3891 6.24902 14.0002 8.46411 14.0002 12.4743V15.9994H9.9375V20.6246H14.0002V31.8056C14.8149 31.9335 15.6498 32 16.5004 32C17.3509 32 18.1859 31.9335 19.0005 31.8056V20.6246H22.7289Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAufb);
export default __webpack_public_path__ + "static/media/aufb.006328cc5b9e8d13d404655f941620d9.svg";
export { ForwardRef as ReactComponent };